// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v6LD","colMin":"styles_colMin__3jyMh"};